import { Route, Routes } from 'react-router-dom';
import React, { useEffect } from 'react';
import AboutPage from './components/Pages/AboutPage';
import ContactPage from './components/Pages/ContactPage';
import ErrorPage from './components/Pages/ErrorPage';
import Home from './components/Pages/Home';
import ServicesPage from './components/Pages/ServicesPage';
import Layout from './components/Layout';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ProductsPage from './components/Pages/ProductsPage';
import ProductDetailsPage from './components/Pages/ProductDetailsPage';
import ProjectPage from './components/Pages/ProjectPage';
import LoginPage from './components/Pages/LoginPage';
import ProfilePage from './components/Pages/ProfilePage';
import RegisterPage from './components/Pages/RegisterPage';
import ResetPassword from './components/Pages/ResetPassword';
import CheckOutPage from './components/Pages/CheckOutPage';
import AllOrders from './components/Pages/AllOrders';


import PrivateRoute from './utils/PrivateRoute';
import AllJobs from './components/Pages/AllJobs';
import AchievementsPage from './components/Pages/AchievementsPage';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />

          <Route path="all-products" element={<ProductsPage />} />
          <Route path="product/:productId" element={<ProductDetailsPage />} />
          <Route path="project" element={<ProjectPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="service" element={<ServicesPage />} />

          <Route path="login" element={<LoginPage />} />
          <Route path="register" element={<RegisterPage />} />
          <Route path="reset-password" element={<ResetPassword />} />

          <Route path="checkout/:productId" element={<PrivateRoute><CheckOutPage /></PrivateRoute>} />
          <Route path="profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path="order-details" element={<PrivateRoute><AllOrders /></PrivateRoute>} />

          <Route path="alljobs" element={<AllJobs />} />
          <Route path="all-achievements" element={<AchievementsPage />} />
          <Route path="about" element={<AboutPage />} />

        </Route>
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default App;
